import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RelevantAnalysisType, RelevantAnalysisTypes } from 'src/app/util/analyses-util/relevant-analysis-service';

@Component({
  selector: 'app-relevant-calculation-selector',
  templateUrl: './relevant-calculation-selector.component.html',
  styleUrl: './relevant-calculation-selector.component.scss',
})
export class RelevantCalculationSelectorComponent {
  relevantAnalysisType = RelevantAnalysisType;
  @Input() relevantAnalysisTypes: RelevantAnalysisTypes = new RelevantAnalysisTypes(false, false, false);
  @Output() relevantAnalysisTypesChange = new EventEmitter<RelevantAnalysisTypes>();

  ButtonClicked(clickedType: RelevantAnalysisType) {
    switch (clickedType) {
      case RelevantAnalysisType.CostCalculation:
        this.relevantAnalysisTypes.ccRelevant = !this.relevantAnalysisTypes.ccRelevant;
        break;
      case RelevantAnalysisType.Lifecycle:
        this.relevantAnalysisTypes.lcaRelevant = !this.relevantAnalysisTypes.lcaRelevant;
        break;
      case RelevantAnalysisType.Recyclability:
        this.relevantAnalysisTypes.recyclingRelevant = !this.relevantAnalysisTypes.recyclingRelevant;
        break;
      case RelevantAnalysisType.PPWR:
        this.relevantAnalysisTypes.ppwrRelevant = !this.relevantAnalysisTypes.ppwrRelevant;
        break;
    }
    this.relevantAnalysisTypes = new RelevantAnalysisTypes(
      this.relevantAnalysisTypes.recyclingRelevant,
      this.relevantAnalysisTypes.lcaRelevant,
      this.relevantAnalysisTypes.ccRelevant,
      this.relevantAnalysisTypes.ppwrRelevant
    );
    this.relevantAnalysisTypesChange.emit(this.relevantAnalysisTypes);
  }

}
